import React from 'react';
import { Navigate } from 'react-router-dom';

// Decode JWT payload client-side (no signature verification — just for redirects)
const getJwtPayload = (token) => {
  try {
    const payload = token.split('.')[1];
    const padded  = payload + '='.repeat((4 - payload.length % 4) % 4);
    return JSON.parse(atob(padded));
  } catch { return null; }
};

const PrivateRoute = ({ children }) => {
  const token = localStorage.getItem('token');
  if (!token) return <Navigate to="/login" replace />;

  const payload     = getJwtPayload(token);
  const currentPath = window.location.pathname;

  // Redirect to onboarding if this user's org hasn't completed it yet.
  // _ob_done is a short-lived localStorage flag set by the onboarding wizard
  // before it navigates away — it protects against silent API failures where
  // the fresh token (with onboarding_complete: true) wasn't stored in time.
  const obDone = localStorage.getItem('_ob_done') === '1';
  if (payload && !payload.onboarding_complete && !obDone && currentPath !== '/onboarding') {
    return <Navigate to="/onboarding" replace />;
  }

  return children;
};

export default PrivateRoute;
